module.exports = __webpack_public_path__ + "img/MARTELO 1,5KG TIPO PENA -mobile.0e636db4.png";